import React from 'react'

import SharedMapMarker from 'components/configured-service/Schedule/SharedMapMarker'
import WeekDayIcon from 'components/configured-service/Schedule/WeekDayIcon'
import { COMMON } from 'theme/colors'

// Matches the WebGL layer's default, so the render path can't change a pin's size.
const ICON_SIZE = 30

// Position, id and handlers ride straight through to `SharedMapMarker`, so they're borrowed rather than restated.
type WeekDayMarkerProps = React.ComponentProps<typeof SharedMapMarker> & {
  weekDays?: string[]
  selectedDaysMap?: Record<string, boolean>
  isActive?: boolean
  isDimmed?: boolean
  borderColor?: string
  iconSize?: number
}

const WeekDayMarker = ({
  weekDays = [],
  selectedDaysMap = {},
  isActive,
  isDimmed = false,
  borderColor = COMMON.white,
  iconSize = ICON_SIZE,
  ...others
}: WeekDayMarkerProps) => {
  return (
    <SharedMapMarker isDimmed={isDimmed} zIndex={isActive ? 1000 : 1} {...others}>
      <WeekDayIcon borderColor={borderColor} borderWidth={1.5} size={iconSize} weekDays={weekDays.filter(day => selectedDaysMap[day])} />
    </SharedMapMarker>
  )
}

export default React.memo(WeekDayMarker)
